/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * The Payment Messages constants text for the payments component.
 * @export
 * @class PaymentMessages
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  paymentListPageTitleAllPayments: {
    id: 'Payments_List_age_Title_AllPayments',
    defaultMessage: 'All payments'
  },
  paymentNameNotApplicable: {
    id: 'Payment_Name_Not_Applicable',
    defaultMessage: 'N/A'
  },
  paymentsNoPaymentsTitle: {
    id: 'Payment_No_Payments_Title',
    defaultMessage: 'No Payments'
  },
  paymentsNoPaymentsDescription: {
    id: 'Payment_No_Payments_Description',
    defaultMessage: 'Payments you are receiving will be shown here'
  },
  action_Back: {
    id: 'Action_Back',
    defaultMessage: 'Back'
  },
  paymentCaseReference: {
    id: 'Payment_Case_Reference',
    defaultMessage: '({caseReference})'
  }
});